export class Modal {
    constructor() {
        this.title = "Upppsss...";
        this.content = "";
        this.init();
    }

    init() {
        const closeButton = document.querySelector('.popUp_footer button');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                this.hide();
            });
        }
    }

    show(title, content) {
        this.title = title ? title : this.title;
        this.content = content ? content : this.content;
        document.querySelector('html').classList.add('no-scroll');
        document.querySelector('.popUP').classList.add('open');
        document.querySelector('.popUP .popUp_header p ').innerHTML = this.title

        document.querySelector('.popUP .popUp_body p ').innerHTML = this.content
    }

    hide() {
        document.querySelector('html').classList.remove('no-scroll');
        document.querySelector('.popUP').classList.remove('open');
    }
}